import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'

const Block = styled.div`
  background-color: ${sv.color.silver};
  position: relative;
  padding: ${sm.mathVars(sv.spacing.uxxlarge, '*', 2)} 0;
`

const AbsoluteImage = styled.img`
  position: absolute;
`

const TopRightImage = styled(AbsoluteImage)`
  top: 0;
  right: -1px;
  height: 160px;
`

export default { Block, TopRightImage, AbsoluteImage }
